// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__36nLI","calendarButtons":"ClockData_calendarButtons__3I-ck"};